// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cCHsJ","name":"styles_name__zJRDb","phone":"styles_phone__2y6pB"};